import {
    baseUrl
} from '@/config/env';
import request from '@/router/axios';
import {
    parseParam
} from '@/util/util';
/**
 * 
 * @returns 修改时数据结构如下
 * {
    "id": 1,
    "rootDepartId": "8a8083b169c223920169c27b14a000c9",
    "content": "124388999条4",
    "deleteFlag": 0,
    "createBy": "慧家",
    "createTime": "2025-11-13 13:51:47",
    "updateBy": null,
    "updateTime": null
}
 */
// DELETE合同/joins-resource/v1/contract/{ids}
// ids: string 格式为 "1,2,3"
export const deleteContract = (ids) => {
    // 确保ids是字符串格式
    let idsStr = ids;
    // 如果ids是数组，将其转换为逗号分隔的字符串
    if (Array.isArray(ids)) {
        idsStr = ids.join(',');
    } else if (typeof ids !== 'string') {
        // 如果是其他类型，转换为字符串
        idsStr = String(ids);
    }
    
    return request({
        url: `${baseUrl}/joins-resource/v1/contract/${idsStr}`,
        method: 'DELETE'
    })
}
// passOrNoContract 审核通过/拒绝
export const passOrNoContract = (data) => {
    return request({
        url: `${baseUrl}/joins-resource/v1/app_contract`,
        method: 'PUT',
        data: data
    })
}
// 通过id查询劳务人员签约详情
export const getContractPersonDetail = (id) => {
    return request({
        url: `${baseUrl}/joins-resource/v1/contract/${id}`,
        method: 'GET'
    })
}
// /joins-resource/v1/contract新增劳务人员
export const addContractPerson = (data) => {
    return request({
        url: `${baseUrl}/joins-resource/v1/contract`,
        method: 'POST',
        data: data
    })
}
// /joins-resource/v1/contract获取劳务人员列表
export const getContractPersonList = (params) => {
    console.log('managingStaff.js ~ line: 32 ~ params ->', params);
    return request({
        url: `${baseUrl}/joins-resource/v1/contract?${parseParam(params)}`,
        method: 'GET'
    })
}
export const getContractTemplate = () => {
    return request({
        url: `${baseUrl}/joins-resource/v1/contract_template`,
        method: 'GET'
    })
}
export const addContractTemplate = (data) => {
    return request({
        url: `${baseUrl}/joins-resource/v1/contract_template`,
        method: 'POST',
        data: data
    })
}
export const editContractTemplate = (data) => {
    return request({
        url: `${baseUrl}/joins-resource/v1/contract_template`,
        method: 'PUT',
        data: data
    })
}
